/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Guid } from "guid-typescript";
import { GlobalConstants } from "../constants/global-constants";

export class AnnotationSettingsInfo {
    textId!: string;
    discardButtonName!: string;
    saveButtonName!: string;
    applyToSelectionButtonName!: string;
}

export class AnnotationSettings {
    ductAnnotation: Annotation[] = [];
    pipeAnnotation: Annotation[] = [];
    conduitAnnotation: Annotation[] = [];
    cableTrayAnnotation: Annotation[] = [];
}

export class Annotation {
    id!: string;
    annotationName!: string;
    annotationID!: string;
    active!: string;
    option!: string;
    location!: string;
    xOffset!: string;
    yOffset!: string;
    tagPath!: string;
    showLeader!: string;
    horizontal!: string;
    showBorder!: string;
    fittingTagPath!: string;
    ignoreLength!: string;

    constructor(tabName: string, annotationType: string, revitVersion: string) {
        this.id = Guid.create().toString();
        switch (annotationType) {
            case GlobalConstants.SIZE_ANNOTATION_NAME:
                this.annotationName = GlobalConstants.SIZE_ANNOTATION_NAME;
                this.annotationID = '1';
                this.option = 'Direction';
                break;
            case GlobalConstants.ELEVATION_ANNOTATION_NAME:
                this.annotationName = GlobalConstants.ELEVATION_ANNOTATION_NAME;
                this.annotationID = '2';
                this.option = 'Direction';
                break;
            case GlobalConstants.ITEM_NUMBER_ANNOTATION_NAME:
                this.annotationName = GlobalConstants.ITEM_NUMBER_ANNOTATION_NAME;
                this.annotationID = '3';
                break;
            case GlobalConstants.SPOOL_ANNOTATION_NAME:
                this.annotationName = GlobalConstants.SPOOL_ANNOTATION_NAME;
                this.annotationID = '4';
                this.option = 'One Item';
                break;
            default:
                this.annotationName = '';
                break;
        }
        this.active = 'False';
        this.location = 'Above';
        this.xOffset = '0';
        this.yOffset = '0';
        this.tagPath = this.getTagPath(tabName, annotationType, revitVersion);
        this.showLeader = 'False';
        this.horizontal = 'False';
        this.showBorder = 'False';
        this.fittingTagPath = this.getFittingsTagPath(tabName, annotationType, revitVersion);
        this.ignoreLength = '0';
    }

    private getTagPath(tabName : string, annotationType: string, revitVersion: string): string {
        switch (tabName){
            case GlobalConstants.CABLE_TRAY_TAB_NAME:
                switch (annotationType){
                    case GlobalConstants.SIZE_ANNOTATION_NAME:
                        return GlobalConstants.TAG_FAMILIES_PATH + revitVersion + '\\' + GlobalConstants.CABLETRAY_SIZE_TAG + '_v' + revitVersion + GlobalConstants.TAG_FAMILY_EXTENSION;
                    case GlobalConstants.ELEVATION_ANNOTATION_NAME:
                        return GlobalConstants.TAG_FAMILIES_PATH + revitVersion + '\\' + GlobalConstants.CABLETRAY_ELEVATION_TAG + '_v' + revitVersion + GlobalConstants.TAG_FAMILY_EXTENSION;
                    case GlobalConstants.ITEM_NUMBER_ANNOTATION_NAME:
                        return GlobalConstants.TAG_FAMILIES_PATH + revitVersion + '\\' + GlobalConstants.CABLETRAY_ITEM_NUMBER_TAG + '_v' + revitVersion + GlobalConstants.TAG_FAMILY_EXTENSION;
                    case GlobalConstants.SPOOL_ANNOTATION_NAME:
                        return GlobalConstants.TAG_FAMILIES_PATH + revitVersion + '\\' + GlobalConstants.CABLETRAY_SPOOL_TAG + '_v' + revitVersion + GlobalConstants.TAG_FAMILY_EXTENSION;
                    default:
                        return '';
                }
            case GlobalConstants.CONDUIT_SETTINGS_TAB_NAME:
                switch (annotationType){
                    case GlobalConstants.SIZE_ANNOTATION_NAME:
                        return GlobalConstants.TAG_FAMILIES_PATH + revitVersion + '\\' +  GlobalConstants.CONDUIT_SIZE_TAG + '_v' + revitVersion + GlobalConstants.TAG_FAMILY_EXTENSION;
                    case GlobalConstants.ELEVATION_ANNOTATION_NAME:
                        return GlobalConstants.TAG_FAMILIES_PATH + revitVersion + '\\' +  GlobalConstants.CONDUIT_ELEVATION_TAG + '_v' + revitVersion + GlobalConstants.TAG_FAMILY_EXTENSION;
                    case GlobalConstants.ITEM_NUMBER_ANNOTATION_NAME:
                        return GlobalConstants.TAG_FAMILIES_PATH + revitVersion + '\\' +  GlobalConstants.CONDUIT_ITEM_NUMBER_TAG + '_v' + revitVersion + GlobalConstants.TAG_FAMILY_EXTENSION;
                    case GlobalConstants.SPOOL_ANNOTATION_NAME:
                        return GlobalConstants.TAG_FAMILIES_PATH + revitVersion + '\\' +  GlobalConstants.CONDUIT_SPOOL_TAG + '_v' + revitVersion + GlobalConstants.TAG_FAMILY_EXTENSION;
                    default:
                        return '';
                }
            default:
                return '';
        }
    }

    private getFittingsTagPath(tabName : string, annotationType: string, revitVersion: string): string {
        switch (tabName){
            case GlobalConstants.CABLE_TRAY_TAB_NAME:
                switch (annotationType){
                    case GlobalConstants.SIZE_ANNOTATION_NAME:
                        return GlobalConstants.TAG_FAMILIES_PATH + revitVersion + '\\' +  GlobalConstants.CABLETRAY_SIZE_TAG + '_v' + revitVersion + GlobalConstants.TAG_FAMILY_EXTENSION;
                    case GlobalConstants.ELEVATION_ANNOTATION_NAME:
                        return GlobalConstants.TAG_FAMILIES_PATH + revitVersion + '\\' +  GlobalConstants.CABLETRAY_ELEVATION_TAG + '_v' + revitVersion + GlobalConstants.TAG_FAMILY_EXTENSION;
                    case GlobalConstants.ITEM_NUMBER_ANNOTATION_NAME:
                        return GlobalConstants.TAG_FAMILIES_PATH + revitVersion + '\\' +  GlobalConstants.CABLETRAY_ITEM_NUMBER_FITTING_TAG + '_v' + revitVersion + GlobalConstants.TAG_FAMILY_EXTENSION;
                    case GlobalConstants.SPOOL_ANNOTATION_NAME:
                        return GlobalConstants.TAG_FAMILIES_PATH + revitVersion + '\\' +  GlobalConstants.CABLETRAY_SPOOL_TAG + '_v' + revitVersion + GlobalConstants.TAG_FAMILY_EXTENSION;
                    default:
                        return '';
                }
            case GlobalConstants.CONDUIT_SETTINGS_TAB_NAME:
                switch (annotationType){
                    case GlobalConstants.SIZE_ANNOTATION_NAME:
                        return GlobalConstants.TAG_FAMILIES_PATH + revitVersion + '\\' +  GlobalConstants.CONDUIT_SIZE_TAG + '_v' + revitVersion + GlobalConstants.TAG_FAMILY_EXTENSION;
                    case GlobalConstants.ELEVATION_ANNOTATION_NAME:
                        return GlobalConstants.TAG_FAMILIES_PATH + revitVersion + '\\' +  GlobalConstants.CONDUIT_ELEVATION_TAG + '_v' + revitVersion + GlobalConstants.TAG_FAMILY_EXTENSION;
                    case GlobalConstants.ITEM_NUMBER_ANNOTATION_NAME:
                        return GlobalConstants.TAG_FAMILIES_PATH + revitVersion + '\\' +  GlobalConstants.CONDUIT_ITEM_NUMBER_FITTING_TAG + '_v' + revitVersion + GlobalConstants.TAG_FAMILY_EXTENSION;
                    case GlobalConstants.SPOOL_ANNOTATION_NAME:
                        return GlobalConstants.TAG_FAMILIES_PATH + revitVersion + '\\' +  GlobalConstants.CONDUIT_FITTING_SPOOL_TAG + '_v' + revitVersion + GlobalConstants.TAG_FAMILY_EXTENSION;
                    default:
                        return '';
                }
            default:
                return '';
        }
    }
}

export class TagsState {
    sizeTag: boolean = false;
    elevationTag: boolean = false;
    itemNumberTag: boolean = false;
    spoolTag: boolean = false;
}

export enum DisplayUnit {
    Metric = 0,
    Imperial = 1
}

export class RevitInformation {
    revitVersion: string = '2024';
    revitDisplayUnit: DisplayUnit = DisplayUnit.Metric;
}

export class CurrentSelectionResult {
    validForConduit: boolean = false;
    validForCableTray: boolean = false;
}

export enum AnnotationSettingsTabType
{
    CableTray = 0,
    Conduit = 1
}

export class AnnotationSettingsTagTextLabel{
    labelName!: string;
    xLocation : number = 0;
    yLocation : number = 0;
    angle : number = 0;

    constructor(labelName: string, xLocation: number, yLocation: number, angle: number){
        this.labelName = labelName;
        this.xLocation = xLocation;
        this.yLocation = yLocation;
        this.angle = angle;
    }
}